import { render, staticRenderFns } from "./WebPanelMixin.vue?vue&type=template&id=10c63b36&"
import script from "./WebPanelMixin.vue?vue&type=script&lang=js&"
export * from "./WebPanelMixin.vue?vue&type=script&lang=js&"
import style0 from "./WebPanelMixin.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-add9cc88d1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports